import { callAPI } from "@/api/httpservice";
import { type AuthResponse, type AuthToken } from "@/types/auth.types";

export function setAuthToken() {
  if(localStorage.getItem('authToken')){
    return
  }
  let token = ""
  if(!token){
    throw new Error(
      "Le token d'authentification n'a pas pu être enregistré."
    );
  }
    localStorage.setItem('authToken', token);
}

export function getAuthToken(): AuthToken {
  const localStorageToken = localStorage.getItem("authToken");
  if (localStorageToken) {
    return localStorageToken;
  }
  return null;
}

export function clearAuthToken() {
  if (localStorage.getItem("authToken")) {
    localStorage.removeItem("authToken");
  }
}

export function validateAuthToken(){
  return callAPI<AuthResponse>("GET", `/users/me`, null);
}